export const lightTheme = {
  body: "#ffffff",
  
};
export const darkTheme = {
  body: "#272727",
  
};
